import React from 'react';
import Icon from '../Icon';

function Button({ variant = '', size = '', icon, children, className = '', ...rest }) {
  const cls = `btn ${variant ? `btn-${variant}` : ''} ${size ? `btn-${size}` : ''} ${className}`.trim();
  return (
    <button className={cls} {...rest}>
      {icon && <Icon name={icon} size={16} />}
      {children}
    </button>
  );
}

export default Button;
